import { useState } from 'react';
import {
  BarChart2,
  Building2,
  CalendarClock,
  Download,
  FileCheck2,
  FileText,
  History,
  Info,
  Plus,
  Share,
} from 'lucide-react';
import { Button } from '@marine/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@marine/ui/dropdown-menu';
import { Switch } from '@marine/ui/switch';
import { TenantFormSheet } from '../../components/TenantFormSheet';

export function TenantsPageHeader() {
  const [tenantDialogOpen, setTenantDialogOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-between px-5 py-2 border-b">
        <h1 className="inline-flex items-center gap-2.5 text-sm font-semibold">
          <Building2 className="size-4 text-primary" /> Tenants
        </h1>

        <div className="flex items-center gap-2.5">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button size="sm" variant="outline">
                <FileCheck2 />
                Reports
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[230px]">
              {/* Notifications Toggle */}
              <DropdownMenuItem
                className="justify-between text-muted-foreground"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <span>Enable Notifications</span>
                <Switch defaultChecked size="sm" />
              </DropdownMenuItem>

              <DropdownMenuSeparator />

              {/* Generate Report */}
              <DropdownMenuItem className="gap-2">
                <BarChart2 />
                <span>Generate Report</span>
              </DropdownMenuItem>

              {/* Schedule Report */}
              <DropdownMenuItem className="gap-2">
                <CalendarClock />
                <span>Schedule Report</span>
              </DropdownMenuItem>

              {/* View Report History */}
              <DropdownMenuItem className="gap-2">
                <History />
                <span>View Report History</span>
              </DropdownMenuItem>

              <DropdownMenuSeparator />

              {/* Export CSV */}
              <DropdownMenuItem className="gap-2">
                <Download />
                <span>Export view as CSV</span>
              </DropdownMenuItem>

              {/* Export Excel */}
              <DropdownMenuItem className="gap-2">
                <Share />
                <span>Export view as Excel</span>
              </DropdownMenuItem>

              {/* Import CSV */}
              <DropdownMenuItem className="gap-2">
                <FileText />
                <span>Import CSV</span>
              </DropdownMenuItem>

              <DropdownMenuSeparator />

              {/* Learn */}
              <DropdownMenuItem className="text-muted-foreground">
                <Info />
                <span className="text-sm">Learn more about Reports</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <Button size="sm" onClick={() => setTenantDialogOpen(true)}>
            <Plus /> New Tenant
          </Button>
        </div>
      </div>

      <TenantFormSheet
        open={tenantDialogOpen}
        onOpenChange={setTenantDialogOpen}
        tenant={null}
      />
    </>
  );
}
